import styled from 'styled-components';
import { color } from '../../../theme/Color';

export const NoDataFoundContainer = styled.div<{ mode: string }>`
  border: ${({ mode }) =>
    mode === 'light'
      ? `1px solid ${color._D7E5F8}`
      : `1px solid rgba(255, 255, 255, 0.2)`};
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 20px;
  margin-top: 10px;
  min-height: 265px;
  height: 100%;
  width: 100%;
`;
export const Container = styled.div<{ mode: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  min-height: 100%;
  min-width: 100%;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ErrorText = styled.p<{ mode: string }>`
  font-family: 'Inter';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  color: ${(props) =>
    props.mode === 'light' ? `${color._3a3a3a}` : `${color._D0D0D0}`};
`;
